import { useAppStore } from '@/store/appStore';
import { computed } from 'vue';
import { Role } from '@/router/enum';

export default function useForkliftAdmin() {
  const store = useAppStore();

  return computed(
    () => store.isAdmin || store.permission.includes(Role.FORKLIFT_ADMIN),
  );
}
